module.exports = __webpack_public_path__ + "static/media/sinotrans.f4e6ae86.png";